import api from '@/api';

export default {
  namespaced: true,

  state: {
    corporation: {},
  },

  getters: {
    currentCorpId: state => state.corporation.id,
    currentCorpTitle: state => state.corporation.title,
  },

  actions: {
    async InitCorporation({ commit }, params) {
      const { corporation } = await api.corporation.getCorporation(params);
      commit('SET_CORPORATION', corporation);
      return corporation;
    },
    async UpdateCorporation({ commit }, params) {
      const { corporation } = await api.corporation.putCorporation(params);
      commit('SET_CORPORATION', corporation);
      return corporation;
    },
    async PatchCorporationContacts({ commit }, contacts) {
      const { corporation } = await api.corporation.patchCorporationContacts({ ...contacts });
      commit('SET_CORPORATION', corporation);
      return corporation;
    },
    // eslint-disable-next-line no-unused-vars
    async InitCoordinate({ commit }, params) {
      const newVar = await api.corporation.initCoordinate({ ...params });
      return newVar;
    },
    // eslint-disable-next-line no-unused-vars
    async UpdateCoordinate({ commit }, params) {
      const newVar = await api.corporation.putCoordinate({ ...params });
      return newVar;
    },
    // eslint-disable-next-line no-unused-vars
    async AddCoordinate({ commit }, params) {
      const newVar = await api.corporation.postCoordinate({ ...params });
      return newVar;
    },
    // eslint-disable-next-line no-unused-vars
    async DeleteCoordinate({ commit }, params) {
      const newVar = await api.corporation.deleteCoordinate({ coordinateId: params.id });
      return newVar;
    },
  },

  mutations: {
    SET_CORPORATION(state, corporation) {
      state.corporation = corporation;
    },
  },
};
